import VendorCertificationsContainer from "./VendorCertificationsContainer";

export default VendorCertificationsContainer;
